<template>
	<div  class="main-page">
	  <a-layout id="mainpage">
		  <Header @navbtn-event="handleHeader" :isShowLeftSiderVal="true"></Header>
		  <div ref="ContontDiv" class="ContontDiv" >
			  <a-layout class="layout-cont" style="height: 100vh;"> 

				<transition 
					name="fadeLeft" 
					mode="in-out"
					:duration="{ enter: 500, leave:500 }" 
					v-on:before-leave="beforeLeave"	>
					<template v-if="navShow==true">
						<LeftSider ></LeftSider>
					</template>
				</transition>  
				
					<a-layout style="padding: 0 24px 0px" 
						class="mainRightCont"  :class="changeClassV"
						v-hammer:pan="handlePan" 
						v-hammer:swipe="handleSwipe" v-hammer:swipeleft="handleLeft" v-hammer:swiperight="handleRight" 
					  >
					  <Pposition></Pposition>
					  <p ref="pppRef"></p>
					  <a-layout-content  class="mainItem-cls"  :style="{ paddingTop: '0px', margin: 0,}"> 
						  <template v-if="listData.length>0">
								 <div class="demoDivList" 
								 :style="{left:(-(divWidth+pianYiLiang)+swipedDeltaX) + 'px',width:((divWidth+pianYiLiang)*3)+'px',height:'100vh'}"> 
								   <div class="demoDiv" :style="{width:(divWidth)+'px',marginRight:pianYiLiang+'px' }">
									   <ArtlistCom 
										:listDataVal="listDataPre" :stype="'prevpage'"  
										:pianYiLiang="pianYiLiang" :xlVal="xlVal" :pagination="pagination" :locale="locale" :detail="'detail'"></ArtlistCom>
									   
								   </div>
																			
								   <div ref="demoDiv" class="demoDiv" :style="{width:divWidth+'px',marginRight:pianYiLiang+'px'}">
									   <ArtlistCom :listDataVal="listData" :stype="'curpage'"  
									   :pianYiLiang="pianYiLiang" :xlVal="xlVal" :pagination="pagination" :locale="locale" :detail="'detail'"></ArtlistCom>
								   </div>
																	   
								   <div  class="demoDiv" :style="{width:divWidth+'px',marginRight:pianYiLiang+'px' }">
									   <ArtlistCom :listDataVal="listDataNext" :stype="'nextpage'"  
									   :pianYiLiang="pianYiLiang" :xlVal="xlVal" :pagination="pagination" :locale="locale" :detail="'detail'"></ArtlistCom>
									   
									</div>							 										
								</div> 
								<div class="paginationlist">
									<ul>
										<li>{{pagination.total}} 个文档</li>
										<li>
											<a-pagination size="small"
											v-model="CurPage"
											:default-current="pagination.current"
											:total="pagination.total" 
											:page-size="pagination.pageSize" 
											@change="onChangePage"  
											/>
										</li>
									</ul>
								</div>
							</template>
							<template v-else>
								<a-empty :image="locale.emptyImage" :description="locale.emptyText" />
							</template>
							<p class="aspin-cls" :class="spinningPcls"><a-spin tip="加载中..." :delay="500" :spinning="spinning" /></p>
					  </a-layout-content> 
					</a-layout>   
			  </a-layout>
		  </div>
		</a-layout>
	  <img class="main-bg" src="@/assets/img/main/main-bg.png" alt="" />
	</div>
</template>

<script>
import { mapActions } from 'vuex';
import Header from "./modules/header2.vue";
import LeftSider from "./modules/left4.vue";
import Pposition from "./modules/pposition.vue";  
import ArtlistCom from "./modules/artlist.vue";  
import {findById,findParentPath,modifyNestedArrayById,modifyNestedArrayByKeyName} from '@/utils/util';
var GListData = [];

export default {
  name: "mainPage", 
  components: {
    Header,
	LeftSider,
	Pposition,
	ArtlistCom,
  },
  data() {
	var _self=this;
    return { 
	  collapsed: false,
	  navShow:true,
	  spinning:true,//加载
	  spinningPcls:"active",
	  xlVal:3,	    
	  pageSize:9,
		
		listData:[], 
		listDataPre:[],
		listDataNext:[],
		CurPage:1,
		pagination: {
		  current:1,//当前页
		  onChange: function(page){
			_self.CurPage=page;
			_self.pagination.current=page;
			console.log(page); 
		  },
		  total:0,
		  pageSize:9,
		  size:'small',
		  showTotal:function(total, range){
			  return total +"个文档";//"10个文件夹，"+ 
		  }
		},
		locale:{
			emptyText:"暂无内容", 
			emptyImage:"/assets/img/main/empty-pic.png",  
		},
		
		swipedDirection:"left",
		swipedDeltaX:0,
		
		divWidth:0,
		divHeight:0,
		pianYiLiang:55,
		demoDivListMoveX:0,
		
		
		windowWidth: 0,
		windowHeight: 0,
		leftHieght:0,
		changeClassV:"",
    };
  },
  // 是计算属性,依赖其他属性计算值,并且computed 的值有缓存,只有当计算值变化才会返回内容---自动执行
  //‌适用场景‌：频繁使用的动态值（如过滤、验证等）
  computed: {
	  seltMenuItemVal(){
		  var _self=this;
		  return _self.$store.state.article.seltMenuItem;
	  },
	  listDataVal() { 
		  return this.$store.state.article.resData;
	  },
	  listDataPreVal(){
		  return this.$store.state.article.resDataPre;
	  },
	  listDataNextVal(){
		  return this.$store.state.article.resDataNext;
	  },
	  totalVal(){
		  return this.$store.state.article.total;
	  },
	  LeftHieghtVal(){
		  return this.$store.state.article.leftHieght;
	  },
	  searchKeyWordsMin(){
		  return this.$store.state.article.searchKeyWordsMin;
	  }
  },
  // 使用watch来监听 响应数据的变化---自动执行
  //适用场景‌：数据更新后需执行异步操作（如加载子级数据）
  watch:{  
	  pageSize(newVal, oldVal) { 
		this.pagination.pageSize=newVal;
		//this.$store.state.article.pageSize=newVal;
		this.$store.commit("article/set_pageSize",newVal);
		//console.log("set_pageSize:",newVal);		
		var params={
			id:this.seltMenuItemVal.id,
			page:1,
			pageSize:newVal, 
		};
		var searchKeyWordsMin=this.$store.state.article.searchKeyWordsMin;
		if(searchKeyWordsMin!=="undefined" && searchKeyWordsMin!==null && searchKeyWordsMin!="")
		{
			params.key=searchKeyWordsMin;
		}
		this.requestpostV(this,params);	
		
	  }, 
	  seltMenuItemVal(newVal){
		  console.log("选中的菜单:",newVal);
		  var _self=this;
		  this.$store.commit("article/set_page",1);
		  this.$store.commit("article/set_total",0);		  
		  var params={
			  id:newVal.id,
			  page:this.$store.state.article.page,
			  pageSize:this.$store.state.article.pageSize, 
		  };
		  this.requestpostV(_self,params);
	  },
	  CurPage(newVal){
		console.log("CurPage-切换:",newVal);
		this.$store.commit("article/set_page",newVal); 
		var params={
			id:this.seltMenuItemVal.id,
			page:this.CurPage,
			pageSize:this.$store.state.article.pageSize,  
		};
		var searchKeyWordsMin=this.$store.state.article.searchKeyWordsMin;
		if(searchKeyWordsMin!=="undefined" && searchKeyWordsMin!==null && searchKeyWordsMin!="")
		{
			params.key=searchKeyWordsMin;
		}
		this.requestpostV(this,params);		
	  },
	  searchKeyWordsMin(newVal){	 
		  console.log("searchKeyWordsMin-查找:",newVal);
		  this.CurPage=1;
		  this.$store.commit("article/set_page",1); 
		  var params={
		  	id:this.seltMenuItemVal.id,
		  	page:this.CurPage,
		  	pageSize:this.$store.state.article.pageSize, 
			 key:newVal
		  };
		  this.requestpostV(this,params);	
	  },
	  listDataVal(newVal)
	  {
		this.listData=this.$store.state.article.resData;
		//console.log("m-watch-listDataValCur:",this.listData);
	  },
	  
	  listDataPreVal(newVal)
	  {
	  	this.listDataPre=newVal;
		//console.log("m-watch-listDataPre:",newVal);
	  },
	  listDataNextVal(newVal)
	  {
		this.listDataNext=newVal;
		//console.log("m-watch-listDataNext:",newVal);
	  },
	  totalVal(newVal)
	  {
		this.pagination.total=newVal;//console.log("listDataVal:",newVal);		 
	  },
	  LeftHieghtVal(newVal){
		this.leftHieght=newVal;
	  },
	  navShow(newVal){
		  console.log("navShow:",newVal);
		  var _self=this;
		  //展开侧边栏
		  var i=0;
		  _self.changeClassV="hiddenDiv";
		  var t=setInterval(function(){
			  //console.log("1-----------------:",i);
			  if(i>0.5)
			  {
				  _self.changeClassV="";
				  clearInterval(t);
			  }
			  i+=0.1;
		  },100);
	  },
	  divWidth(newVal){
		  //屏幕尺寸变化时，触发
		  this.updateDimensions();
		  
		  this.CurPage=1;		  
		  this.$store.commit("article/set_page",this.CurPage); 
		  var params={
		  	id:this.seltMenuItemVal.id,
		  	page:this.CurPage,
		  	pageSize:this.$store.state.article.pageSize,  
		  };
		  var searchKeyWordsMin=this.$store.state.article.searchKeyWordsMin;
		  if(searchKeyWordsMin!=="undefined" && searchKeyWordsMin!==null && searchKeyWordsMin!="")
		  {
		  	params.key=searchKeyWordsMin;
		  }
		  this.requestpostV(this,params);		
	  },
	},
	
	activated() {
	  console.log('mainPage-页面被激活')
	  this.intiV();
	},
	deactivated() {
	  console.log('mainPage-页面被缓存')
	},
  created() {
	  this.intiV();
  },
  //与created区别‌：created在模板渲染前执行，mounted在渲染后执行
  mounted() {
	  var _self=this;	
	  var divCont=this.$refs.ContontDiv;
	  var resizeObserver1 = new ResizeObserver(entries => {
	         for (let entry of entries) {
	           var cr = entry.contentRect;
	  		   _self.divHeight=cr.height;
			   _self.$store.commit('article/SetLeftHieght',cr.height);
	           //console.log('ContontDiv: ', cr.height); 
	           //console.log('ContontDiv-windowWidth: ', this.windowWidth+"/"+this.windowHeight); 
	         }
	  });
	  resizeObserver1.observe(divCont); // 开始观察目标元素的大小变化。  
	  
	  var divlist=this.$refs.pppRef;
	  var resizeObserver3 = new ResizeObserver(entries => {
	        for (let entry of entries) {
	          var cr = entry.contentRect;
			  _self.divWidth=cr.width;
			  //_self.demoDivListMoveX=_self.divWidth;
	          //console.log('pp-Width: ', cr.width); // 打印新的宽度值 
	        }
	 });
     resizeObserver3.observe(divlist); // 开始观察目标元素的大小变化。	 
	 
	 
	 this.updateDimensions();
	 window.addEventListener('resize', this.updateDimensions);	 
	  
	 //this.$store.commit('user/choseUserInfo');//在调用方法前加模块文件名以斜杠分隔	  	
	 //_self.listData= _self.$store.state.article.resData;//
  },
	// 里面是用来定义函数的，需要手动才能执行
  methods: {	
	  intiV(){
		  var _self=this;
		  //this.showLoading();
		  console.log("mainpage---created-----------"); 
		  this.$store.commit("article/SetSearchKeyWordsTop","");
		  this.$store.commit("article/SetSearchKeyWordsMin","");
		  //this.$store.commit("article/pageSize",this.pageSize);
		  
		  
			var pageId=1;//this.$store.state.article.page;
			this.CurPage=pageId;
			console.log();
			var total=0;//this.$store.state.article.total;
			this.$store.commit('article/set_total',total);
			var pageSize=this.$store.state.article.pageSize;
			console.log("mainpage---created-----------total:",total);
			console.log("mainpage---created-----------pageSize:",pageSize);
			 
			var  pagination={
			  current:pageId,//当前页
			  onChange: function(page){
				_self.CurPage=pageId;
				_self.pagination.current=pageId;
				//_self.$store.commit("article/set_page",page);
				//console.log(page); 
			  },
			  total:total,
			  pageSize:pageSize,
			  size:'small',
			  showTotal:function(total, range){
				  return total +"个文档";//"10个文件夹，"+ 
		  		  }
		  };
		  _self.pagination=pagination;  
		  console.log("mainpage---created-----------end"); 
	  },
	  beforeLeave(){
		  console.log("minapage-beforeLeave");
	  },
	  onChangePage(pageNumber){
		 // this.pagination.onChange(pageNumber);
		 this.CurPage=pageNumber;
		 //this.$store.commit("article/set_page",pageNumber); 
		 //console.log(pageNumber);
	  },
	  updateDimensions() {
	    this.windowWidth = window.innerWidth;
	    this.windowHeight = window.innerHeight;
		//console.log("showLoading------------windowWidth:",this.windowWidth);
	  },
	  showLoading(){
		  var _self=this;		  
		  _self.spinningPcls="active";
		  _self.spinning=true;
		  console.log("showLoading------------:",_self.spinning);
		  // setTimeout(function(){
			 //  if(_self.spinning==true)
			 //  {
				//   _self.spinning=false;
			 //  }
		  // },1000)
	  }, 
	 //head给菜单传递事件
	 handleHeader(data){
		 this.navShow=data;
		 this.listData=[];
		 //this.$store.commit("article/set_pageSize",this.pageSize);
		 //console.log("handleHeader:",this.navShow);
	 },  
	 handleLeft() { 
	   this.swipedDirection="left";
	   this.swipedDeltaX=0;
	   //console.log("handleLeft---");
	 },
	 handleRight() {  
	   this.swipedDirection="right";
	   this.swipedDeltaX=0;
	   //console.log("handleRight---");
	 },
	 handlePan(event) {
	   //console.log("handlePan---");
	   // event.deltaX 获取水平方向上的移动距离（正值表示向右移动，负值表示向左移动）	   
	   //console.log('handlePan---水平移动距离['+this.swipedDirection+']:', event.deltaX);  
	   var _self=this;
	   if(Math.abs(event.deltaX)<150)
	   {
		   this.swipedDeltaX=event.deltaX;
	   }
	   else{
		   var i=0;
		   var tVal=setInterval(function(){			    
			   if(i==2)
			   {
				   clearInterval(tVal);
				   _self.swipedDeltaX=0;
				   //this.swipeFunV(event);
			   }
			   i+=1;
			   //console.log('handlePan---水平移动距离2:-------------------i:',i); 
		   },1000);
		   //clearInterval(tVal); 
		   //console.log('handlePan---水平移动距离2:-------------------');  
	   }
	 },
	 handleSwipe(event){
		//console.log("Swipe---");
	    //console.log('Swipe---水平移动距离['+this.swipedDirection+']:', event.deltaX);  
		 //this.showLoading();//掩藏
		 //this.swipeFunV(event);
		 if(Math.abs(event.deltaX)>150)
		 {	   
		 	this.swipeFunV(event);
		 }
	 },
	 swipeFunV(event){		 
		 if(this.swipedDirection=="left")
		 {
		 	//左滑 下一页				
			if(Math.abs(event.deltaX)>150)
			{
				this.CurPage=parseInt(this.CurPage)+1;
				var totalPage=Math.ceil(this.pagination.total/this.pagination.pageSize);
				if(this.CurPage>=totalPage)
				{
					this.CurPage=totalPage;
				}
				this.pagination.current=this.CurPage;
				//console.log('totalPage:', totalPage+"---"+this.pagination.total+"---"+this.pagination.pageSize);
				//this.pagination.onChange(this.CurPage);//跳转页面
			}
		 }
		 if(this.swipedDirection=="right" )
		 {
		 	//右滑 上一页			
			if(Math.abs(event.deltaX)>150)
			{ 
				this.CurPage=parseInt(this.CurPage)-1;
				if(this.CurPage<=0)
				{
				   this.CurPage=1;
				}
				//this.pagination.onChange(this.CurPage);//跳转页面
				this.pagination.current=this.CurPage;
				
			} 
		 }
		 this.swipedDeltaX=0;		 
		 //this.$store.commit("article/set_page",this.pagination.current);		 
		 //console.log("Val["+this.swipedDirection+"]:",this.swipedDeltaX);
		 //console.log('水平移动距离[CurPage]:', parseInt(this.CurPage));
	 },
	 requestpostV(_self,params){
		 
		 _self.showLoading();  
		 if(this.navShow==false)
		 { 
			 //掩藏侧边栏
			 this.xlVal=4;
			 params.pageSize=12;
			 
			 if(this.windowWidth>1500)
			 {
			 	 this.xlVal=4;
			 	 params.pageSize=8;
			 }			 
		 }
		 else{
			 //展开
			 this.xlVal=3;
			 params.pageSize=9;			 
			 if(this.windowWidth>1500)
			 {
			 	 this.xlVal=4;
			 	 params.pageSize=8; 
			 }
			 else{
				if(this.windowWidth>=1280 && this.windowHeight<=605)
				{
					this.xlVal=4;
					params.pageSize=8; 
				}
				if(this.windowWidth>=1097 && this.windowHeight<=519)
				{
					this.xlVal=4;
					params.pageSize=8; 
				}				 
			 }
		 }
		 _self.$store.commit("article/set_pageSize",params.pageSize);
		 
		 var cparmas=params;
		 cparmas.istype="curpage"; //当前页
		 this.$store.dispatch("article/GetArticleList",cparmas)
		 .then(res=>{
			 
			 _self.spinning=false;
			 _self.spinningPcls="";
			 console.log("spinning:",_self.spinning);
			 
			 var nparmas=params;
			 nparmas.istype="nextpage";//下一页
			 nparmas.page=(params.page+1);
			 _self.$store.dispatch("article/GetArticleList",nparmas);				 
			 
		 })
		 .then(res=>{
			 var pparmas=params;
			 pparmas.istype="prepage";//上一页
			 pparmas.page=(params.page-2);
			 _self.$store.dispatch("article/GetArticleList",pparmas);
			 
		 });
		 
		 //var listData=_self.$store.state.article.resData;
		 //console.log("m-watch-listDataValCur-curpage:",listData);
		 
		 
		 var pageId=_self.$store.state.article.page;
		 _self.CurPage=pageId;
		 var total=_self.$store.state.article.total;
		 var pageSize=_self.$store.state.article.pageSize;
		 //console.log("params:",params);
		 //console.log("params-total:",total);
		 //console.log("params-pageSize:",pageSize);
		 
		 var  pagination={
			  current:pageId,//当前页
			  onChange: function(page){
				_self.CurPage=page;
				_self.pagination.current=page;
				_self.$store.commit("article/set_page",page);
			  },
			  total:total,
			  pageSize:pageSize,
			  size:'small',
			  showTotal:function(total, range){
				  return total +"个文档";//"10个文件夹，"+ 
			  }
		};
		_self.pagination=pagination;
		 
	 },
  },  
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDimensions);
  },
  
};
</script>

<style lang="scss" scoped> 
.main-page {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  background-color: #f1f3f5;
  .main-bg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 300px;
    z-index: 0;
  } 
  #mainpage,.layout-cont,.mainRightCont{
	  background: unset;z-index: 1;
  }
} 

.ContontDiv{ height:93.75vw!important;}
.mainRightCont{  
	position: relative; 
	padding-left: 20px!important;
	transition:all 0.3s;
	.mainItem-cls{max-height:80vh; position: relative; overflow: hidden;height: auto; transition:all 0.3s} 
	
	.pagination-2{
		padding-right: 10px;
		.ant-pagination{ text-align: right;}
	}
	.aspin-cls{ text-align: center; position: absolute;width: 100%; height: 50px; top: 33.3%;left: 0;z-index: 100; display: none;}
	.aspin-cls.active{ display: block;}
	
	.demoDivList{ 
		display:flex;position: absolute;height: 100%;left: 0px; top: 0px;white-space: nowrap; transition:all 0.3s;
		.demoDiv{ height:100vh}
	}
	.paginationlist{ 
		 position: absolute;left: 0px;width: 100%; z-index: 100;bottom:10px;
		 ul{
			width: 100%; height: 30px; position: relative;
			li{width: 50%; float: left;}
			li:nth-child(1){ text-align: left;padding-left: 11px; font-size: 14px; color: rgba(25, 26, 26, 1);}
			li:nth-child(2){ text-align: right;}
		 }
	} 
}
.hiddenDiv{opacity: 0;transition:all 0.3s}
.hiddenDiv2{opacity: 0;}


@media (max-width:420px){
	.artlist-item{  margin-top: 8px;}
}
</style>
<style>
	.mainRightCont .demoDiv .ant-list{max-height: 100%;height:78vh}  
	@media (min-width:1536px){
		.mainRightCont .mainItem-cls{max-height:75vh!important;}
	} 
</style>